import { fork } from "redux-saga/effects"

import { execDAuthInitial } from "sagas/DAuth"
import { handleGetAgreementSelection } from "sagas/GetAgreementSelection"
import { handlePutAdvertisingAgreements } from "sagas/PutAdvertisingAgreements"
import { handlePutPersonalRelationAgreements } from "sagas/PutPersonalRelationAgreements"
import { handlePutThirdPartyAgreements } from "sagas/PutThirdPartyAgreements"

export default function* rootSaga() {
  yield fork(execDAuthInitial)
  yield fork(handleGetAgreementSelection)
  yield fork(handlePutPersonalRelationAgreements)
  yield fork(handlePutAdvertisingAgreements)
  yield fork(handlePutThirdPartyAgreements)
}
